<template>
    <span
            v-if="shown"
            v-bind:style="nodeContainerStyle"
            class="node-container">
        <div
                v-on:click="$emit('job-type-clicked', jobType)"
                v-bind:style="jobTypeNameStyle"
                class="job-type-name noselect">
            {{ label }}
        </div>
        <template v-if="areChildrenExpanded">
            <div class="chevron-container">
                <i class="fa fa-chevron-right" aria-hidden="true"></i>
            </div>
            <JobTypeEditNode
                    v-if="jobType !== undefined"
                    v-for="jobType in orderedChildren"
                    v-bind:key="jobType.id"
                    v-bind:jobType="jobType"
                    v-bind:selectedJobType="selectedJobType"
                    v-on:job-type-clicked="$emit('job-type-clicked', $event)">
            </JobTypeEditNode>
        </template>
    </span>
</template>

<script>
    import {JobType} from './JobType';

    export default {
        name: 'JobTypeEditNode', // needed for a recursive component
        props: {
            jobType: JobType,
            selectedJobType: JobType
        },
        computed: {
            shown() {
                if (this.selectedJobType === null) {
                    return this.jobType.isRoot();
                }
                return this.jobType.isChildThisOrAncestorOf(this.selectedJobType);
            },
            label() {
                if (
                    this.jobType.isRoot()
                    && this.selectedJobType === null
                ) {
                    return this.jobType.name.substr(0, 4);
                }
                return this.jobType.name;
            },
            nodeContainerStyle() {
                return {
                    marginRight: this.jobType.isRoot() ? '0' : '3px'
                };
            },
            jobTypeNameStyle() {
                if (
                    this.jobType.isRoot()
                    || (
                        this.selectedJobType !== null
                        && this.jobType.isThisOrAncestorOf(this.selectedJobType)
                    )
                ) {
                    return {
                        backgroundColor: this.jobType.getRoot().color
                    };
                }
                else {
                    return {
                        backgroundColor: '#e8e8e8',
                        color: 'black'
                    };
                }
            },
            orderedChildren() {
                return this.jobType.children
                    .sort(
                        (jobTypeA, jobTypeB) => jobTypeA.order > jobTypeB.order ? 1 : -1
                    )
                ;
            },
            areChildrenExpanded() {
                return (
                    this.selectedJobType !== null
                    && this.jobType.isThisOrAncestorOf(this.selectedJobType)
                    && this.jobType.children.length > 0
                );
            }
        }
    }
</script>

<style scoped lang="scss">
    .node-container {
    }
    .job-type-name {
        display: inline-block;
        cursor: pointer;
        padding: 9px 10px;
        color: white;
        font-size: 14px;
        margin-top: 3px;
        &:hover {
            background: red;
        }
    }
    .children {
        display: inline-block;
    }
    .chevron-container {
        display: inline-block;
        padding: 0 6px;
        color: grey;
    }
</style>
